import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import HistoryForm from "../_components/HistoryForm";
import styles from "../Notice.module.css";
import apiService from "../../../../services/api";

export default function FormClient() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // 수정 모드인지 확인
    const [historyData, setHistoryData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // 수정 모드일 때 기존 데이터 가져오기
    useEffect(() => {
        if (id) {
            const fetchHistoryData = async () => {
                setLoading(true);
                try {
                    const response = await apiService.getHistory();
                    const histories = response.histories || response || [];
                    const currentHistory = histories.find(history => history.id === parseInt(id));
                    
                    if (currentHistory) {
                        setHistoryData(currentHistory);
                    } else {
                        console.error('연혁을 찾을 수 없습니다:', id);
                        alert('연혁 정보를 찾을 수 없습니다.');
                        navigate("/admin/notices");
                    }
                } catch (error) {
                    console.error('연혁 데이터 가져오기 실패:', error);
                    alert('연혁 정보를 가져오는데 실패했습니다.');
                    navigate("/admin/notices");
                } finally {
                    setLoading(false);
                }
            };
            
            fetchHistoryData();
        }
    }, [id, navigate]);
    
    const handleSubmit = () => {
        // 성공 후 연혁 탭으로 돌아가기
        navigate("/admin/notices?tab=history");
    };
    
    const handleCancel = () => {
        // 취소 시 연혁 탭으로 돌아가기
        navigate("/admin/notices?tab=history");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>연혁 수정</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>{id ? "연혁 수정" : "연혁 등록"}</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                
                <HistoryForm 
                    item={historyData} // 실제 연혁 데이터 전달
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}